import { Divider } from 'components/shared/Divider';

import { BedroomsBathroomsFilter } from './BedroomsBathroomsFilter';
import type { BedroomsBathroomsFilterProps } from './BedroomsBathroomsFilter';
import { HomeFeaturesFilter } from './HomeFeaturesFilter';
import type { HomeFeaturesFilterProps } from './HomeFeaturesFilter';
import { HomeTypeFilter } from './HomeTypeFilter';
import type { HomeTypeFilterProps } from './HomeTypeFilter';
import { LotSizeFilter } from './LotSizeFilter';
import type { LotSizeFilterProps } from './LotSizeFilter';
import { PriceFilter } from './PriceFilter';
import type { PriceFilterProps } from './PriceFilter';
import { SquareFootageFilter } from './SquareFootageFilter';
import type { SquareFootageFilterProps } from './SquareFootageFilter';
import { YearBuiltFilter } from './YearBuiltFilter';
import type { YearBuiltFilterProps } from './YearBuiltFilter';

export type SearchFiltersProps = PriceFilterProps &
  BedroomsBathroomsFilterProps &
  SquareFootageFilterProps &
  HomeTypeFilterProps &
  HomeFeaturesFilterProps &
  YearBuiltFilterProps &
  LotSizeFilterProps & {
    canSelfTour?: boolean | null;
    onCanSelfTourChange?: (value: string) => void;
  };

export const SearchFilters = (props: SearchFiltersProps) => {
  return (
    <>
      <PriceFilter
        minPrice={props?.minPrice}
        maxPrice={props?.maxPrice}
        handleMinPriceChange={props.handleMinPriceChange}
        handleMaxPriceChange={props.handleMaxPriceChange}
        handleError={props.handleError}
        errors={props.errors}
      />
      <Divider my="$15x" />
      <BedroomsBathroomsFilter
        minBaths={props?.minBaths}
        minBeds={props?.minBeds}
        handleMinBathsChange={props.handleMinBathsChange}
        handleMinBedsChange={props.handleMinBedsChange}
      />
      <Divider my="$15x" />
      <HomeTypeFilter
        singleFamily={props?.singleFamily}
        condo={props?.condo}
        townhome={props?.townhome}
        handleSingleFamilyChange={props.handleSingleFamilyChange}
        handleCondoChange={props.handleCondoChange}
        handleTownhomeChange={props.handleTownhomeChange}
      />
      <Divider my="$15x" />
      <HomeFeaturesFilter
        noHoas={props?.noHoas}
        singleStory={props?.singleStory}
        fhaEligible={props?.fhaEligible}
        mustHavePool={props?.mustHavePool}
        handleNoHoasChange={props.handleNoHoasChange}
        handleSingleStoryChange={props.handleSingleStoryChange}
        handleFhaEligibleChange={props.handleFhaEligibleChange}
        handlePoolChange={props.handlePoolChange}
      />
      <Divider my="$15x" />
      <YearBuiltFilter
        minYearBuilt={props?.minYearBuilt}
        maxYearBuilt={props?.maxYearBuilt}
        handleMinYearBuiltChange={props.handleMinYearBuiltChange}
        handleMaxYearBuiltChange={props.handleMaxYearBuiltChange}
        handleError={props.handleError}
        errors={props.errors}
      />
      <Divider my="$15x" />
      <SquareFootageFilter
        minSquareFootage={props?.minSquareFootage}
        maxSquareFootage={props?.maxSquareFootage}
        handleMinSquareFootageChange={props.handleMinSquareFootageChange}
        handleMaxSquareFootageChange={props.handleMaxSquareFootageChange}
        handleError={props.handleError}
        errors={props.errors}
      />
      <Divider my="$15x" />
      <LotSizeFilter
        minLotSize={props?.minLotSize}
        maxLotSize={props?.maxLotSize}
        handleMinLotSizeChange={props.handleMinLotSizeChange}
        handleMaxLotSizeChange={props.handleMaxLotSizeChange}
        handleError={props.handleError}
        errors={props.errors}
      />
    </>
  );
};
